export default __webpack_public_path__ + "static/construction-offer-416bd287d8a955e404ea330bad1d898d.png";